/**
 * 探索区域数据
 */

export interface Zone {
  id: string;
  name: string;
  icon: string;
  desc: string;
  /** 最低境界索引（0=炼气, 1=筑基...） */
  minRealm: number;
  /** 是否已解锁（达到境界后自动解锁） */
  unlocked?: boolean;
  /** 灵草掉率倍率 */
  herbBonus: number;
  /** 妖丹掉率倍率 */
  coreBonus: number;
  /** 灵石倍率 */
  stoneBonus: number;
  /** 经验倍率 */
  expBonus: number;
  /** 敌人强度修正（1.0=正常） */
  enemyPower: number;
}

export const ZONES: Zone[] = [
  // ===== 炼气期 =====
  {
    id: 'bamboo_forest',
    name: '青竹林',
    icon: '🎋',
    desc: '灵气稀薄的竹林，偶有野兽出没。适合初入仙途者历练。',
    minRealm: 0,
    herbBonus: 1.5,
    coreBonus: 0,
    stoneBonus: 1.0,
    expBonus: 1.0,
    enemyPower: 1.0,
  },
  {
    id: 'misty_valley',
    name: '迷雾谷',
    icon: '🌫️',
    desc: '常年被雾气笼罩的山谷，有毒蛇和山贼盘踞。灵草丰富但较为危险。',
    minRealm: 0,
    herbBonus: 2.0,
    coreBonus: 0,
    stoneBonus: 0.7,
    expBonus: 1.2,
    enemyPower: 1.3,
  },

  // ===== 筑基期 =====
  {
    id: 'spirit_beast_ridge',
    name: '灵兽岭',
    icon: '⛰️',
    desc: '妖兽和灵兽的栖息地，妖丹的重要来源。',
    minRealm: 1,
    herbBonus: 1.0,
    coreBonus: 1.8,
    stoneBonus: 1.2,
    expBonus: 1.3,
    enemyPower: 1.0,
  },
  {
    id: 'dark_forest',
    name: '黑风林',
    icon: '🌲',
    desc: '参天古木遮天蔽日，邪修和树精在此修炼。灵草遍地但危机四伏。',
    minRealm: 1,
    herbBonus: 2.2,
    coreBonus: 0.8,
    stoneBonus: 1.0,
    expBonus: 1.1,
    enemyPower: 1.2,
  },

  // ===== 金丹期 =====
  {
    id: 'demon_swamp',
    name: '魔沼',
    icon: '💀',
    desc: '瘴气弥漫的沼泽，鬼王和魔道修士的巢穴。妖丹产出极为丰富。',
    minRealm: 2,
    herbBonus: 0.5,
    coreBonus: 2.5,
    stoneBonus: 1.5,
    expBonus: 1.5,
    enemyPower: 1.2,
  },
  {
    id: 'dragon_abyss',
    name: '蛟龙渊',
    icon: '🐉',
    desc: '深不见底的峡谷，蛟龙潜伏其中。高风险高回报。',
    minRealm: 2,
    herbBonus: 0.3,
    coreBonus: 3.0,
    stoneBonus: 2.0,
    expBonus: 2.0,
    enemyPower: 1.5,
  },

  // ===== 元婴期+ =====
  {
    id: 'ancient_battlefield',
    name: '上古战场',
    icon: '⚔️',
    desc: '远古修士大战的遗迹，天魔和修罗徘徊不去。',
    minRealm: 3,
    herbBonus: 0.5,
    coreBonus: 2.5,
    stoneBonus: 2.0,
    expBonus: 2.0,
    enemyPower: 1.0,
  },
  {
    id: 'celestial_peak',
    name: '通天峰',
    icon: '🏔️',
    desc: '高耸入云的山峰，域外天魔和堕仙在此游荡。唯有强者才能踏足。',
    minRealm: 4,
    herbBonus: 1.0,
    coreBonus: 3.0,
    stoneBonus: 3.0,
    expBonus: 3.0,
    enemyPower: 1.2,
  },
];

/** 获取玩家可进入的区域列表 */
export function getAvailableZones(realmIndex: number): Zone[] {
  return ZONES.filter((z) => z.minRealm <= realmIndex);
}
